export const findSelectedFee = (itinerary, selectedFeeType) =>
  itinerary.fees.find(({ type }) => type.id === selectedFeeType.id);
